module.exports = "/images/starts.svg?b1a5626ab0935faeb335161864a39aca";


//////////////////
// WEBPACK FOOTER
// ./resources/images/starts.svg
// module id = 2Xi2
// module chunks = 0